<template>
  <div class='edit-icon-category-component'>
     <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>ICON分类</th>
                <th>排序号</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in categoryList">
                <td>{{item.categoryId}}</td>
                <td>{{item.categoryName}}</td>
                <td>
                  <input type="number" class="input width-1" v-model="item.sort" @change="onSort(item.categoryId, item.sort)">
                </td>
                <td>{{item.status ? '显示': '隐藏'}}</td>
                <td>
                  <button class="button is-primary" @click='editIcon(item)'>编辑</button>
                </td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
      <el-dialog :title="modal.title" :visible.sync="modal.visible">
        <div class='modal-wrap'>
          <div class='category-name-wrap'>
            <label for="categoryName" class='category-name-label'>分类名称:</label>
            <input class="input width-3" v-model="modal.categoryName">
          </div>
          <div class='control input-wrap'>
            <label for="phone">在用户端:</label>
            <input class='radio' type="radio" name='status' v-model='modal.status' value='1'>显示
            <input class='radio' type="radio" name='status' v-model='modal.status' value='0'>隐藏
         </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modal.visible = false">取 消</el-button>
          <el-button type="primary" @click="modalOK">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script type="text/babel">
  export default { 
    data() {
      return {
        categoryList: [],
        modal: {
          title: '编辑Icon分类',
          visible: false,
          categoryName: '',
          categoryId: 0,
          status: 0
        },
      }
    },
    mounted() {
      this.getCategoryList()
    },
    methods:{
      modalOK() {
        this.doSaveCategory()
        this.modal.visible = false;
      },
      getCategoryList() {
        HttpRequest.get('/admin.php?method=blogger.getIconCategoryList').then(response => {
          this.categoryList = response.data;
        })
      },
      onSort(categoryId, sort) {
        let params = {
          categoryId: categoryId,
          sort: sort
        }
        HttpRequest.get('/admin.php?method=blogger.doSaveIconCategorySort', params).then(response => {
          if (response.data.success) {
            this.$message('修改成功')
          }
        })
      },
      editIcon(category) {
        this.modal.visible = true
        this.modal.categoryId = category.categoryId
        this.modal.categoryName = category.categoryName
        this.modal.status = category.status
      },
      doSaveCategory() {
        let params = {
          categoryName: this.modal.categoryName,
          categoryId: this.modal.categoryId,
          status: this.modal.status
        }
        HttpRequest.get('/admin.php?method=blogger.doSaveIconCategory', params).then(response => {
          if (response.data.success === 1) {
            this.getCategoryList();
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  table td {
    text-align: center;
  }
  .modal-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .category-name-wrap {
    display: flex;
    align-items: center;
  }
</style>